export const catBreeds = [
  'Européen',
  'Chat de maison',
  'Abyssinien',
  'African Shorthair',
  'Aladseer',
  'LaPerm',
  'Américain à poil court',
  'Américain à poil dur',
  'Américain Curl',
  'Maine Coon',
  'Ragdoll',
  'Angora turc',
  'Aphrodite Giant Cat',
  'Mau Arabe',
  'Asiatique',
  'Bombay',
  'Burmese',
  'Burmilla',
  "Léopard d'Asie",
  'Chantilly-Tiffany',
  'Balinais',
  'Bengale',
  'Birman',
  'British Longhair',
  'Siamois',
  'Pixie-bob',
  'Brazillian Shorthair',
  'British Shorthair',
  'Persan',
  'Rex de Cornouailles',
  'California Spangled',
  'Chartreux',
  'Chausie',
  'Cheetoh',
  'Colorpoint à poil court',
  'Bobtail Japonais',
  'Devon Rex',
  'Mau Egyptien',
  'Poil court européen',
  'Exotic Shorthair',
  'Oriental Shorthair',
  'Chat des forêts norvégiennes',
  'Brun de la Havane',
  'Javanais',
  'Keetso',
  'Korat',
  'Lykoi',
  'Manx',
  'Munchkin',
  'Nebelung',
  'Ocicat',
  'Peterbald',
  'Bleu russe',
  'Savannah',
  'Scottish Fold',
  'Selkirk Rex',
  'Serengeti',
  'Sibérien',
  'Singapour',
  'Snowshoe',
  'Somali',
  'Sphynx',
  'Chat chocolaté du Suffolk',
  'Tonkinois',
  'Toyger',
  'Van turc',
  'York Chocolate Cat',
]

export const dogBreeds = [
  'Affenpinscher',
  'Afghan',
  'Africain sans poils',
  'Airedale Terrier',
  'Akbash',
  'Akita',
  'Alano Espagnol',
  'Alapaha Blue Blood Bulldog',
  'Américain Mancon',
  'American Bully',
  'American Mastiff',
  'Ariégeois',
  'Aussiedoodle',
  'Autres grands chiens',
  'Bakharwal',
  'Bandogge Mastiff',
  'Barbet',
  'Barzoï',
  'Basenji',
  'Basset Artésien Normand',
  'Basset Bleu De Gascogne',
  'Basset Fauve de Bretagne',
  'Basset Griffon',
  'Basset Hound',
  'Beagle',
  'Beauceron',
  'Bedlington Terrier',
  'Berger Allemand',
  'Berger Australien',
  'Berger Blanc Suisse',
  "Berger d'Anatolie",
  'Berger de Bergame',
  'Berger de Bohème',
  'Berger de Karst',
  'Berger des Carpates',
  "Berger d'Europe de l'Est",
  'Berger Tchécoslovaque',
  'Bichon Caniche',
  'Bichon Frisé',
  'Bichon Havanais',
  'Bichpoo',
  'Blue Heeler',
  'Boerboel',
  'Borador',
  'Border Collie',
  'Border Terrier',
  'Bouche Noir Cur',
  'Bouledogue',
  'Bouledogue Américain',
  'Bouledogue français',
  'Bouvier',
  'Bouvier Australien',
  'Bouvier Bernois',
  'Bouvier des Açores',
  'Bouvier des Flandres',
  'Bouvier Saint Miguel',
  'Boxer',
  'Braque Allemand',
  'Braque du Bourbonnais',
  'Braque Italien',
  'Briard français',
  'Bug',
  'Buggle',
  'Bull Terrier',
  'Bulldog miniature',
  'Bulldog anglican',
  'Bulldog australien',
  'Bullmastiff',
  'Bullmastiff américain',
  'Bullmastiff des Pyrénées',
  'Bullmastiff français',
  'Bully Kutta',
  'Bully Indien',
  'Cairn Terrier',
  'Can de Palleiro',
  'Canaan',
  'Cane Corsos',
  'Caniche',
  'Caniche nain',
  'Caniche royal',
  'Canin',
  'Cao de Castro Laboreiro',
  'Cao Fila',
  'Carea Leones',
  'Carlin',
  'Cavachon',
  'Cavalier King Charles',
  'Cavapoo',
  'Chesapeake Bay Retriever',
  'Chi-A-Pap',
  'Chien Argentin',
  'Chien Canari',
  'Chien courant',
  'Chien courant bulgare',
  'Chien courant Crétois',
  'Chien courant de Bavière',
  'Chien courant de Halden',
  'Chien courant de Harrier',
  'Chien courant de Lettonie',
  'Chien courant de Prague',
  "Chien courant d'Hamilton",
  "Chien courant d'Ibiza",
  "Chien courant d'Istrie",
  "Chien courant d'Ours de Carélie",
  'Chien courant du Groenland',
  'Chien courant du Jura',
  'Chien courant Polonais',
  'Chien courant Serbe',
  "Chien d'arrêt Allemand",
  "Chien d'arrêt Allemand à poil long",
  "Chien d'arrêt Anglais",
  "Chien d'arrêt Slovaque",
  'Chien de Berger Anglais',
  'Chien de Berger Belge',
  'Chien de Berger Britannique',
  'Chien de Berger Catalan',
  "Chien de Berger d'Anatolie",
  "Chien de Berger d'Argentine",
  "Chien de Berger d'Asie Centrale",
  'Chien de Berger de Bosnie',
  'Chien de Berger de Bucovine',
  'Chien de Berger de Laponie',
  'Chien de Berger de Picardie',
  'Chien de Berger de Travail',
  'Chien de Berger du Caucase',
  'Chien de Berger Grec',
  'Chien de Berger Hollandais',
  'Chien de Berger Hongrois',
  'Chien de Berger Islandais',
  'Chien de Berger Polonais de Tatra',
  'Chien de Berger Portugais',
  'Chien de Berger Roumain',
  'Chien de Berger Roumain de Mioritza',
  'Chien de chasse français',
  'Chien de chasse polonais',
  "Chien de Montagne de l'Entlebucher",
  'Chien de Montagne des Pyrénées',
  'Chien de perdrix de Drentse',
  'Chien de Posavac',
  'Chien de renne de Laponie',
  'Chien de sang',
  'Chien de Tamasquie',
  'Chien de traîneau sibérien de Seppala',
  "Chien d'eau espagnol",
  "Chien d'eau portugais",
  "Chien d'Elkhound Norvégien",
  "Chien d'Estrela",
  'Chien du Brésil',
  'Chien du désert de Libye',
  'Chien du Pharaon',
  'Chien Eskimo Canadien',
  'Chien finlandais de Laponie',
  'Chien français de porcelaine',
  'Chien Léopard de Catahoula',
  'Chien Loup',
  'Chien polonais de plaine',
  'Chien rouge chinois',
  'Chien Suédois de Laponie',
  'Chien-loup de Sarloos',
  'Chien-loup tchécoslovaque',
  'Chiens inuits du Nord',
  'Chihuahua',
  'Chin japonais',
  'Chinois à crête',
  'Chion',
  'Chi-Shi',
  'Chiweenie',
  'Chorkie',
  'Chow Chow',
  'Chug',
  "Cirneco Dell'Etna",
  'Clumber Spaniel',
  'Cockapoo',
  'Cocker Anglais',
  'Cocker Spaniel',
  'Colley',
  'Colley à poil dur',
  'Colley à poil ras',
  'Colley barbu',
  'Colley de Ferme',
  'Collie Irlandais',
  'Coonhound noir et feu',
  'Corgi',
  'Coton de Tuléar',
  'Créole',
  'Croix Carea Leones',
  'Croix Kangal Turc',
  'Croix Utonagan',
  'Dachsbracke des Alpes',
  'Dalmatien',
  'Dandie Dinmont',
  'Deerhound écossais',
  'Dingo Australien',
  'Dobermann',
  'Dogue Allemand',
  'Dogue Brésilien',
  'Dogue de Bordeaux',
  'Doxiedoodle',
  'Doxiepoo',
  'Doxihuahua',
  'Drever',
  'Epagneul Allemand',
  'Epagneul Boykin',
  'Epagneul breton',
  'Epagneul de Picardie',
  'Epagneul de Springer',
  'Epagneul de Sussex',
  "Epagneul d'eau américain",
  "Epagneul d'eau Irlandais",
  'Epagneul du Tibet',
  'Epagneul Français',
  'Eurasier',
  'Fell Terrier',
  'Field Spaniel',
  'Fila Brasileiro',
  'Flat Coated Retriever',
  'Fox',
  'Fox hound',
  'Fox Terrier',
  'Foxhound Américain',
  'Galgo Espanol',
  'Glen of Imaal Terrier',
  'Golden Retriever',
  'Gonczy Polski',
  'Grand Bouvier Suisse',
  'Grand Danois',
  'Griffon',
  'Griffon Bleu de Gascogne',
  'Griffon Bruxellois',
  'Griffon de Korthais',
  'Griffon de Nevers',
  'Griffon Fauve de Bretagne',
  'Groupe des chiens de chasse',
  'Harzer Fuchs',
  'Havane',
  'Heeler de Lancashire',
  'Hellenikos Poimenikos',
  'Highland Terrier',
  'Hokkaîdo',
  'Hovawart',
  'Huntaway',
  'Husky',
  "Husky d'Alaska",
  'Hybride de loup',
  "Indien d'Amérique",
  'Irish Wheaten Terrier',
  'Italiano Spinone',
  'Jack Chi',
  'Jack Russell',
  'Jack Russell Terrier',
  'Jackahuahua',
  'Jackapoo',
  'Jamthund',
  'Jindo Coréen',
  'Kangal Turc',
  'Karabash',
  "Karabash d'Anatolie",
  'Karakachan',
  'Keeshond',
  'Kelpie Australien',
  'Kerry Beagle',
  'Kerry Blue Terrier',
  "Kleekai d'Alaska",
  'Kokoni',
  'Kooikerhondje',
  'Kromfohrlander',
  'Kuvasz',
  'Kuvasz Hongrois',
  'Labradoodle',
  'Labradoodle Australien',
  'Labradoodle miniature',
  'Labrador',
  'Lagotto Romagnolo',
  'Laizhou Hong',
  'Lakeland Terrier',
  'Lapsk Vallhund',
  'Laufhund Suisse',
  'Leavitt Bulldog',
  'Leonberger',
  'Lévrier',
  'Lévrier Afghan',
  'Lévrier Espagnol',
  'Lévrier Hongrois',
  'Lévrier Irlandais',
  'Lévrier Polonais',
  'Lévrier de course',
  'Lévrier Grec',
  'Lévrier Greyhound',
  'Lhasa Apso',
  'Liaka Sibérien',
  'Lowchen',
  'Lucas Terrier',
  'Lurcher',
  'Magyar Agar',
  "Malamute d'Alaska",
  'Mal-Shi',
  'Maltais',
  'Maltipoo',
  'Manchester Terrier',
  'Maremma',
  'Mastiff',
  'Mastiff américain de Bandogge',
  'Mastiff Argentin',
  'Mastiff Brésilien',
  'Mastiff du Tibet',
  'Mastiff Espagnol',
  'Mastiff Napolitain',
  'Mastiff Pakistanais',
  'Mastiff Serbe',
  "Mastiff d'Afrique du Sud",
  'Mâtin indien',
  'Mexicain sans poil',
  'Mi-Ki',
  'Mudi Hongrois',
  'Munsterlander',
  'Nova Scotia Duck Tolling Retriever',
  'Olde English Bulldogge',
  'Otterhound',
  'Ovcharka du Caucase',
  'Papchi',
  'Papihuahua',
  'Papillon',
  'Pariah',
  'Patterdale Terrier',
  'Peagle',
  'Pekeapoo',
  'Pékinois',
  'Perro de Presa Canarios',
  'Perro Majorero',
  'Pinscher',
  'Pinscher Allemand',
  'Pit Bull',
  'Pit Bull Mastiff',
  'Pit Bull Terrier',
  'Pit Bull Terrier Américain',
  'Podenco Canario',
  'Podenco Enano',
  'Podengo portugais',
  'Pointer',
  'Pointer à poil dur',
  'Pointer Danois',
  'Pointer de Burgos',
  'Pomapoo',
  'Pomchi',
  'Poméranien',
  'Pomsky',
  'Poochon',
  'Presa Canarios',
  'Pugalier',
  'Pugapoo',
  'Puli Hongrois',
  'Queensland Heeler',
  'Rat Terrier',
  'Ratonero Bodeguero Andaluz',
  'Retriver à poil raide',
  'Rhodesian Ridgeback',
  'Rottweiler',
  'Russkiy Toy',
  'Sabueso Espanol',
  'Saluki',
  'Samoyède',
  'Sarplaninac yougoslave',
  'Schapendoes',
  'Schipperke',
  'Schnauzer',
  'Schnauzer miniature',
  'Schnauzer géant',
  'Schnoodle',
  'Scottish Terrier',
  'Sealyham Terrier',
  'Segugio Italiano',
  'Setter',
  'Setter Anglais',
  'Setter Français',
  'Setter Gorden',
  'Setter Irlandais',
  'Setter Irlandais Rouger et Blanc',
  'Setters',
  'Shar Pei',
  'Sheepadoodle',
  'Sheepapoo',
  'Shetland Sheepdog',
  'Shi Chi',
  'Shiba Inu Japonais',
  'Shichon',
  'Shih Tzu',
  'Shih-Poo',
  'Shikoku',
  'Shorkie',
  'Siberian Husky',
  'Shye Terrier',
  'Sloughi',
  'Spaniel Field',
  'Spitz',
  'Spitz Allemand',
  'Spitz Finlandais',
  'Spitz japonais',
  'Springer Spaniel',
  'Springerdoodle',
  'Springerpoo',
  'Sprocker Spaniel',
  'Sproodle',
  'Saint Bernard',
  'Stabyhoun',
  'Staffordshire Bull Terrier',
  'Staffordshire Terrier Américain',
  'Teckel',
  'Teckel miniature',
  'Teckeldoodle',
  'Teckelpoo',
  'Terre-Neuve',
  'Terridoodle',
  'Terrier',
  'Terrier américain sans poil',
  'Terrier Anglais',
  'Terrier Anglais miniature',
  'Terrier Australien',
  'Terrier Belge',
  'Terrier Biewer',
  'Terrier Brésilien',
  'Terrier de Boston',
  'Terrier de Chasse Allemand',
  'Terrier de Norfolk',
  'Terrier de Norwich',
  'Terrier de Nuttall',
  'Terrier de Plummer',
  'Terrier du Tibet',
  'Terrier Irlandais',
  'Terrier soyeux',
  'Terrier Tchèque',
  'Terripoo',
  'Texas Heeler',
  'Thai Ridgeback',
  'Tosa',
  'Tosa Inus',
  'Tosa Japonais',
  'Utonagan',
  'Vallhund Suédois',
  'Vizsla Hongrois',
  'Volpino Italiano',
  'Weirmaraner',
  'Welsh',
  'Welsh Collie',
  'Welsh Terrier',
  'West Highland Terrier',
  'Wetterhoun',
  'Whippet',
  'Yorkie-Chi',
  'Yorkiehuahua',
  'Yorkiepoo',
  'Yorkshire Terrier (Miniature)',
  'Zuchon',
]
